import React, { useEffect } from 'react';
import logo from '../../logo.svg';
import '../navbar/Navbar.css';
import '../dashboard.css';
import { Link, useNavigate } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogTitle, IconButton, DialogActions } from '@mui/material';
import CurrentStockList from '../stock/CurrentStock';
import Cookies from 'js-cookie';
import { hideOptions } from '../../utils/config';

function Toolbar() {
  const [userName, setUserName] = React.useState("");
  const [openUserist, setOpenUserList] = React.useState(false);
  const [openUserMgmtui, setOpenUserMgmtui] = React.useState(false);
  const navigate = useNavigate();

  const openCurrentStockUI = () => {
    setOpenUserList(true)
  }

  const openManageUserDlg = () => {
    setOpenUserMgmtui(true)
  }

  const handleListClose = () => {
    
    setOpenUserList(false)
  };

  const handleUserDlgClose = () => {
    
    setOpenUserMgmtui(false)
  };
  

  useEffect(() => {
      var cookiedata:any =  Cookies.get('auth')
    
    if (!!cookiedata) {
      var cookieObj =   JSON.parse(cookiedata)
      if (!!cookieObj && !!cookieObj.username) {
            setUserName(cookieObj.username);
      } else {
        navigate("../login")
      }
    
    } else {
      navigate("../login")
    }
  }, []);


  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },

  }));

  interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
  }

  function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }


  ///
  const doLogout = () => {

    Cookies.remove("auth");
    navigate("/", { replace: true });

    // browserhistory.replace("../")
    // props.navigation.reset(0)
  }


  return (
    <div className="App">
      <div className="align-items-baseline m-0 row mt-2">
        <div className="col-6 text-left pl-0 "><img src={logo} className="width_17per" /></div>

        <div className="col-4 "></div>

        <div className="col-2 text-right pr-0 ">
          <div className="text-right">
            <tr >

              <td>  <Link to="#" >
                <a className="dropdown-item" style={{ color: 'blue' }} onClick={openCurrentStockUI} href="#">Stock</a>
              </Link>  </td>

              <td>

                <nav className="navbar navbar-expand-lg  p-0  mt-2">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarText"
                    aria-controls="navbarText"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>


                  <div className="collapse navbar-collapse" id="navbarText">
                    <ul className="navbar-nav mr-auto">
                      <li className="nav-item dropdown pr-2">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          id="navbarDropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Welcome {userName}
                        </a>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdownMenuLink">
                          <Link to="#" hidden={hideOptions()} >
                            <a className="dropdown-item" href="#" onClick={openManageUserDlg}  hidden >Manage User</a>
                          </Link>
                          <Link to="#" >
                            <a className="dropdown-item" href="#"  hidden >Reset Password</a>
                          </Link>
                          <Link to="#" >
                            <a className="dropdown-item" href="#" onClick={doLogout}  >Logout</a>
                          </Link>

                        </div>
                      </li>
                    </ul>
                  </div>

                </nav>
              </td> </tr></div>
        </div>
      </div>

      <>
        <BootstrapDialog

          fullWidth
          maxWidth="md"
          onClose={handleListClose}
          aria-labelledby="customized-dialog-title"
          open={openUserist}>

          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleListClose}>
            Current Stock
          </BootstrapDialogTitle>

          <CurrentStockList></CurrentStockList>

          <DialogActions>

          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog

          fullWidth
          maxWidth="md"
          onClose={handleUserDlgClose}
          aria-labelledby="customized-dialog-title"
          open={openUserMgmtui}>

          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleUserDlgClose} >
            Manage Users
          </BootstrapDialogTitle>

          <CurrentStockList></CurrentStockList>

          <DialogActions>

          </DialogActions>
        </BootstrapDialog>
      </>
    </div>
  );
}

export default Toolbar;